import PreDeliveryInspectionBanner from "../pre-delivery-inspection-banner/component";
import PreDeliveryInspectionDetails from "../pre-delivery-inspection-details/component";
import PreDeliveryInspectionFaqs from "../pre-delivery-insection-faqs/component";
import { PAGE_LAYOUT } from "./constants";

export const getComponent = (pageSection) => {
    if (pageSection.startsWith("PDI_HERO_BANNER")) {
        return PreDeliveryInspectionBanner;
    } else if (pageSection.startsWith("PDI_SEO_CONTENT")) {
        return PreDeliveryInspectionDetails;
    } else if (pageSection.startsWith("PDI_FAQ")) {
        return PreDeliveryInspectionFaqs;
    } else return PAGE_LAYOUT[pageSection];
};
